<div class="casinoGames-main">
  <div
    (click)="this.closedModal()"
    class="close-icon-container"
    style="display: flex; width: 100%; justify-content: flex-end; position: fixed; padding-right: 10px; margin-top: 10px">
    <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
  </div>

  <ng-container *ngIf="!this.isError">
    <div class="casinoGames-main-iframe" [style.height]="this.isSliderMenu ? 'calc(var(--vh) - 40px - 140px)' : 'calc(var(--vh) - 0px)'">
      <ng-container [ngSwitch]="this.gameType">
        <ng-container *ngSwitchCase="'html'">
          <div [innerHtml]="safeHtmlContent" class="casinoGames-iframe"></div>
        </ng-container>
        <ng-container *ngSwitchCase="'url'">
          <iframe
            id="lsframe"
            [src]="this.safeHtmlContent"
            frameborder="0"
            border-width="0"
            position="static"
            allowfullscreen="true"
            width="100%"
            height="90%"
            allow="geolocation;camera;microphone"></iframe>
        </ng-container>
        <ng-container *ngSwitchCase="'UrlRedirect'">
          <iframe
            id="UrlRedirect"
            [src]="this.safeHtmlContent"
            sandbox="allow-same-origin allow-top-navigation allow-popups allow-scripts"
            frameborder="0"
            border-width="0"
            position="static"
            allowfullscreen="true"
            width="100%"
            height="90%"
            allow="geolocation;camera;microphone"></iframe>
        </ng-container>
        <ng-container *ngSwitchCase="'script'">
          <ng-container *ngIf="this.gameData?.providerId === 9; else scriptGames"></ng-container>
          <iframe
            id="scriptFrame"
            [src]="this.safeHtmlContent"
            frameborder="0"
            border-width="0"
            position="static"
            allowfullscreen="true"
            width="100%"
            height="90%"
            allow="geolocation;camera;microphone"></iframe>
          <ng-template #scriptGames>
            <div [innerHtml]="safeHtmlContent" class="casinoGames-iframe"></div>
            <div id="egamings_container"></div>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="this.isError">
    <div class="games-error-container" [style.height]="this.isSliderMenu ? 'calc(var(--vh) - 40px - 140px)' : 'calc(100vh - 40px - 10px)'">
      {{ 'casino.lobby.game_not_found' | translate }}
    </div>
  </ng-container>
  <div
    *ngIf="this.providerData.gameList && this.providerData.gameList.length > 0"
    class="casino-bottom-gameList"
    [style.transform]="!this.isSliderMenu ? 'translateY(120px)' : 'translateY(0)'">
    <slider-component
      [items]="this.providerData.gameList"
      [providerName]="this.gameData?.providerName"
      pageName="dialog"
      [isSliderMenu]="this.isSliderMenu"
      (sliderMenuAction)="this.sliderMenuAction()"></slider-component>
  </div>
</div>
